import HttpUtils from './http'
import Vue from 'vue'
class Https {
  // 开发票
  createIncoice = (parmas) => {
    return HttpUtils.post('/invoice/invoiceOpen', parmas)
  }
  // 发票详情
  invoiceDetail = (parmas) => {
    return HttpUtils.get('/invoice/invoiceDatilQuery', parmas)
  }
  // 开票查询
  addInvoiceSearch = (parmas) => {
    return HttpUtils.get('/invoice/invoiceOrderQuery', parmas)
  }
  // 查询发票
  getgetSavedInvoices =(params) => {
    return HttpUtils.get('/invoice/invoiceQuery', params)
  }
}
Vue.prototype.$http = new Https()



// WEBPACK FOOTER //
// ./src/http/index.js